// Prev/next context for the document detail page: the ordered ids of the list a document was
// opened from (documents list or patient view), kept in sessionStorage so it survives a reload.
const DOCUMENT_NAVIGATION_KEY = 'documentNavigation';

/** Store `documentIds` as the list to page through, positioned at `documentId`. */
export function saveDocumentNavigation(documentIds, documentId) {
  const currentIndex = documentIds.indexOf(documentId);
  if (documentIds.length === 0 || currentIndex === -1) return;
  try {
    sessionStorage.setItem(DOCUMENT_NAVIGATION_KEY, JSON.stringify({
      documentIds,
      currentIndex
    }));
  } catch (error) {
    console.warn('Failed to save navigation context to session storage:', error);
  }
}

/**
 * The stored list positioned at `documentId` (the new position is written back), or null when
 * there is no stored list or `documentId` is not in it.
 * @returns {{ documentIds: string[], currentIndex: number }|null}
 */
export function readDocumentNavigation(documentId) {
  try {
    const stored = sessionStorage.getItem(DOCUMENT_NAVIGATION_KEY);
    if (!stored) return null;
    const context = JSON.parse(stored);
    const currentIndex = context.documentIds.indexOf(documentId);
    if (currentIndex === -1) return null;
    const positioned = { ...context, currentIndex };
    sessionStorage.setItem(DOCUMENT_NAVIGATION_KEY, JSON.stringify(positioned));
    return positioned;
  } catch (error) {
    console.warn('Failed to read navigation context from session storage:', error);
    return null;
  }
}

export function clearDocumentNavigation() {
  try {
    sessionStorage.removeItem(DOCUMENT_NAVIGATION_KEY);
  } catch (error) {
    console.warn('Failed to clear navigation context from session storage:', error);
  }
}
